import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {StepperModule} from 'primeng/stepper';
import {ReactiveFormsModule} from '@angular/forms';
import { CommonModule, NgClass } from '@angular/common';
import {BillingModelPackage} from '../../../../../models/billing/BillingModelPackage';
import {RmaCurrencyPipe} from "../../../../../rma-pipes/rma-currency.pipe";

export interface BillingPackage {
  packageSize: BillingModelPackage;
  baseCost: number;
  additionalCost: number;
}

@Component({
  selector: 'ibp-package-select-item',
  templateUrl: './package-select-item.component.html',
  styleUrls: ['./package-select-item.component.scss'],
  standalone: true,
  imports: [
    StepperModule,
    ReactiveFormsModule,
    NgClass,
    CommonModule,
    RmaCurrencyPipe
  ],
})
export class PackageSelectItemComponent {
  @Input() public billingPackage: BillingPackage;
  @Input() public disabled = false;
  @Input() public selected = false;
  @Output() public select = new EventEmitter<any>();
  @Input() public mainCurrency = 'CHF';

  @HostListener('click')
  onClick(): void {
    this.select.emit(this.billingPackage.packageSize);
  }
}
